// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textinputs {
  border-radius: 10px;
  background-color: #edecf8;
  border: 1px solid #edecf8;
  height: 45px;
  display: inline;
}

.loginicon {
  margin-left: 15px;
  margin-right: 10px;
  height: 19px;
  margin-top: 10px;
  display: inline;
}

.textinputbody {
  display: flex;
  padding: 5px;
  border-radius: 10px;
  background-color: #edecf8;
  width: 100%;
  position: relative;
}

.signinform {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 0px 20px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  padding-top: 30px;
  padding-bottom: 30px;
}

.loginbtn {
  margin: 0 auto;
  width: 100%;
  height: 48px;
  margin-bottom: 10px;
}

.firsthalf {
  margin-left: 100px;
  margin-right: 50px;
  margin-top: 150px;
}

.secondhalftop {
  margin-left: 70px;
  margin-right: 70px;
  margin-top: 10px;
  margin-bottom: 0px;
}

.secondhalfsecond {
  margin-top: 19px;
  margin-left: 70px;
  margin-right: 70px;
}

.secondhalfthird {
  margin-left: 70px;
  margin-right: 70px;
}

.toptop {
  margin-top: 30px;
}

.eyeicon {
  position: absolute;
  right: 5%;
}

@media (min-width: 297px) and (max-width: 970px) {
  .firsthalf {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
    margin-bottom: 50px;
  }

  .secondhalftop {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
  }

  .secondhalfsecond {
    margin-top: 19px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .secondhalfthird {
    margin-left: 20px;
    margin-right: 20px;
  }
}

@media (min-width: 100px) and (max-width: 293px) {
  .firsthalf {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
    margin-bottom: 50px;
  }

  .secondhalftop {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
  }

  .secondhalfsecond {
    margin-top: 19px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .secondhalfthird {
    margin-left: 20px;
    margin-right: 20px;
  }
}

@media (min-width: 1000px) and (max-width: 1150px) {
  .firsthalf {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
    margin-bottom: 50px;
  }

  .secondhalftop {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
  }

  .secondhalfsecond {
    margin-top: 19px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .secondhalfthird {
    margin-left: 20px;
    margin-right: 20px; 
  }


}
@media (max-width: 1150px){
  .firsthalf{
    margin-top: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/auth/SignIn.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;;AAGF;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".textinputs {\n  border-radius: 10px;\n  background-color: #edecf8;\n  border: 1px solid #edecf8;\n  height: 45px;\n  display: inline;\n}\n\n.loginicon {\n  margin-left: 15px;\n  margin-right: 10px;\n  height: 19px;\n  margin-top: 10px;\n  display: inline;\n}\n\n.textinputbody {\n  display: flex;\n  padding: 5px;\n  border-radius: 10px;\n  background-color: #edecf8;\n  width: 100%;\n  position: relative;\n}\n\n.signinform {\n  width: 100%;\n  border-radius: 10px;\n  box-shadow: 0 0px 20px 0 rgba(0, 0, 0, 0.2);\n  background-color: #ffffff;\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n\n.loginbtn {\n  margin: 0 auto;\n  width: 100%;\n  height: 48px;\n  margin-bottom: 10px;\n}\n\n.firsthalf {\n  margin-left: 100px;\n  margin-right: 50px;\n  margin-top: 150px;\n}\n\n.secondhalftop {\n  margin-left: 70px;\n  margin-right: 70px;\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\n.secondhalfsecond {\n  margin-top: 19px;\n  margin-left: 70px;\n  margin-right: 70px;\n}\n\n.secondhalfthird {\n  margin-left: 70px;\n  margin-right: 70px;\n}\n\n.toptop {\n  margin-top: 30px;\n}\n\n.eyeicon {\n  position: absolute;\n  right: 5%;\n}\n\n@media (min-width: 297px) and (max-width: 970px) {\n  .firsthalf {\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-top: 10px;\n    margin-bottom: 50px;\n  }\n\n  .secondhalftop {\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-top: 10px;\n  }\n\n  .secondhalfsecond {\n    margin-top: 19px;\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .secondhalfthird {\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n}\n\n@media (min-width: 100px) and (max-width: 293px) {\n  .firsthalf {\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-top: 10px;\n    margin-bottom: 50px;\n  }\n\n  .secondhalftop {\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-top: 10px;\n  }\n\n  .secondhalfsecond {\n    margin-top: 19px;\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .secondhalfthird {\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n}\n\n@media (min-width: 1000px) and (max-width: 1150px) {\n  .firsthalf {\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-top: 10px;\n    margin-bottom: 50px;\n  }\n\n  .secondhalftop {\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-top: 10px;\n  }\n\n  .secondhalfsecond {\n    margin-top: 19px;\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .secondhalfthird {\n    margin-left: 20px;\n    margin-right: 20px; \n  }\n\n\n}\n@media (max-width: 1150px){\n  .firsthalf{\n    margin-top: 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
